/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EarnedBadge } from './EarnedBadge';
import {
    EarnedBadgeFromJSON,
    EarnedBadgeFromJSONTyped,
    EarnedBadgeToJSON,
    EarnedBadgeToJSONTyped,
} from './EarnedBadge';
import type { MyDropAchievementEntry } from './MyDropAchievementEntry';
import {
    MyDropAchievementEntryFromJSON,
    MyDropAchievementEntryFromJSONTyped,
    MyDropAchievementEntryToJSON,
    MyDropAchievementEntryToJSONTyped,
} from './MyDropAchievementEntry';

/**
 * 
 * @export
 * @interface MyDropAchievementListResponse
 */
export interface MyDropAchievementListResponse {
    /**
     * The ladder — locked and unlocked, with progress on what is still out there.
     * @type {Array<MyDropAchievementEntry>}
     * @memberof MyDropAchievementListResponse
     */
    achievements: Array<MyDropAchievementEntry>;
    /**
     * The collection — every badge the member has been granted. Permanent; a config change or period reset cannot un-earn it.
     * @type {Array<EarnedBadge>}
     * @memberof MyDropAchievementListResponse
     */
    inventory: Array<EarnedBadge>;
    /**
     * 
     * @type {number}
     * @memberof MyDropAchievementListResponse
     */
    totalUnlocked: number;
    /**
     * 
     * @type {number}
     * @memberof MyDropAchievementListResponse
     */
    totalActive: number;
    /**
     * Badges owned. The number that belongs beside a member's name.
     * @type {number}
     * @memberof MyDropAchievementListResponse
     */
    totalOwned: number;
}

/**
 * Check if a given object implements the MyDropAchievementListResponse interface.
 */
export function instanceOfMyDropAchievementListResponse(value: object): value is MyDropAchievementListResponse {
    if (!('achievements' in value) || value['achievements'] === undefined) return false;
    if (!('inventory' in value) || value['inventory'] === undefined) return false;
    if (!('totalUnlocked' in value) || value['totalUnlocked'] === undefined) return false;
    if (!('totalActive' in value) || value['totalActive'] === undefined) return false;
    if (!('totalOwned' in value) || value['totalOwned'] === undefined) return false;
    return true;
}

export function MyDropAchievementListResponseFromJSON(json: any): MyDropAchievementListResponse {
    return MyDropAchievementListResponseFromJSONTyped(json, false);
}

export function MyDropAchievementListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MyDropAchievementListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'achievements': ((json['achievements'] as Array<any>).map(MyDropAchievementEntryFromJSON)),
        'inventory': ((json['inventory'] as Array<any>).map(EarnedBadgeFromJSON)),
        'totalUnlocked': json['totalUnlocked'],
        'totalActive': json['totalActive'],
        'totalOwned': json['totalOwned'],
    };
}

export function MyDropAchievementListResponseToJSON(json: any): MyDropAchievementListResponse {
    return MyDropAchievementListResponseToJSONTyped(json, false);
}

export function MyDropAchievementListResponseToJSONTyped(value?: MyDropAchievementListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'achievements': ((value['achievements'] as Array<any>).map(MyDropAchievementEntryToJSON)),
        'inventory': ((value['inventory'] as Array<any>).map(EarnedBadgeToJSON)),
        'totalUnlocked': value['totalUnlocked'],
        'totalActive': value['totalActive'],
        'totalOwned': value['totalOwned'],
    };
}

